import React from "react";
import { useNavigate } from "react-router-dom";

const AppMessage = ({
  type = "info", // "info", "error", "success", "warning"
  title,
  message,
  style = {},
  children,
  showHomeButton = false, // add this prop to control button visibility
}) => {
  const navigate = useNavigate();
  let bg, color;
  switch (type) {
    case "error":
      bg = "#ffe5e5";
      color = "#d32f2f";
      break;
    case "success":
      bg = "#e6ffed";
      color = "#388e3c";
      break;
    case "warning":
      bg = "#fff8e1";
      color = "#ff9800";
      break;
    default:
      bg = "#f3d881e3";
      color = "#333";
  }

  return (
    <div
      className="rounded shadow-sm d-flex flex-column align-items-center justify-content-center text-center mt-3"
      style={{
        background: bg,
        color,
        padding: "0.8rem",
        width: "100%",
        ...style,
      }}
    >
      {title && <div className="fw-bold fs-5 mb-2">{title}</div>}
      {message && <div>{message}</div>}
      {children}
      {showHomeButton && (
        <button
          className="btn btn-link mt-3"
          style={{ textDecoration: "underline", color: "#0d6efd", fontWeight: 500, fontSize: "1rem" }}
          onClick={() => navigate("/")}
        >
          Back to Home
        </button>
      )}
    </div>
  );
};

export default AppMessage;